import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'
import { getThemeColors } from '../theme'

export default function Header({ theme, session, perfil }) {
  const C = getThemeColors(theme)
  const navigate = useNavigate()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(() => (typeof window !== 'undefined' ? window.innerWidth <= 900 : false))
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return undefined
    const onResize = () => setIsMobile(window.innerWidth <= 900)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  const handleLogout = async () => {
    await supabase.auth.signOut()
    navigate('/login')
  }

  const userInitial = perfil?.nombre 
    ? perfil.nombre[0].toUpperCase() 
    : session?.user?.email?.[0]?.toUpperCase() || 'U'

  return (
    <nav style={{
      background: C.white,
      borderBottom: `0.5px solid ${C.border}`,
      padding: isMobile ? '10px 12px' : '12px 32px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'sticky',
      top: 0,
      zIndex: 100,
    }}>
      <div
        onClick={() => navigate('/')}
        style={{
          fontSize: '15px',
          fontWeight: '500',
          color: C.text,
          letterSpacing: '-0.3px',
          cursor: 'pointer',
        }}>
        Job<span style={{ color: C.blue }}>Pipeline</span>
      </div>

      <div style={{ display: 'flex', gap: isMobile ? '6px' : '10px', alignItems: 'center' }}>
        {!isMobile && (
          <button
            onClick={() => navigate('/faqs')}
            style={{
              fontSize: '12px',
              color: C.muted,
              background: C.bg,
              border: `0.5px solid ${C.border}`,
              borderRadius: '6px',
              padding: '6px 12px',
              cursor: 'pointer',
            }}>
            FAQs
          </button>
        )}

        <div style={{ position: 'relative' }} ref={dropdownRef}>
          <div
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
              padding: '4px 8px',
              borderRadius: '6px',
              transition: 'background-color 0.15s',
              backgroundColor: isDropdownOpen ? C.bg : 'transparent',
            }}
            onMouseEnter={(e) => !isDropdownOpen && (e.currentTarget.style.backgroundColor = C.bg)}
            onMouseLeave={(e) => !isDropdownOpen && (e.currentTarget.style.backgroundColor = 'transparent')}
          >
            <div
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                background: C.blueLight,
                color: C.blue,
                fontSize: '12px',
                fontWeight: '500',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              {userInitial}
            </div>

            {!isMobile && (
              <span style={{ fontSize: '12px', color: C.subtle, maxWidth: '140px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {session?.user?.email}
              </span>
            )}

            <span style={{ fontSize: '10px', color: C.muted, marginLeft: '2px' }}>
              ▼
            </span>
          </div>

          {isDropdownOpen && (
            <div
              style={{
                position: 'absolute',
                top: '100%',
                right: 0,
                background: C.white,
                border: `0.5px solid ${C.border}`,
                borderRadius: '8px',
                marginTop: '4px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                zIndex: 1000,
                minWidth: '180px',
              }}>
              <button
                onClick={() => {
                  navigate('/perfil')
                  setIsDropdownOpen(false)
                }}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '10px 14px',
                  background: 'none',
                  border: 'none',
                  fontSize: '13px',
                  color: C.text,
                  cursor: 'pointer',
                  borderBottom: `0.5px solid ${C.border}`,
                  transition: 'background-color 0.1s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = C.bg)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'none')}>
                👤 Perfil
              </button>

              <button
                onClick={() => {
                  navigate('/configuracion')
                  setIsDropdownOpen(false)
                }}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '10px 14px',
                  background: 'none',
                  border: 'none',
                  fontSize: '13px',
                  color: C.text,
                  cursor: 'pointer',
                  borderBottom: `0.5px solid ${C.border}`,
                  transition: 'background-color 0.1s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = C.bg)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'none')}>
                ⚙️ Configuración
              </button>

              <button
                onClick={() => {
                  handleLogout()
                  setIsDropdownOpen(false)
                }}
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '10px 14px',
                  background: 'none',
                  border: 'none',
                  fontSize: '13px',
                  color: C.red,
                  cursor: 'pointer',
                  transition: 'background-color 0.1s',
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = C.redBg)}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'none')}>
                🚪 Cerrar sesión
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  )
}
